import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import api from "@/lib/api";
import Browse from "@/pages/Browse";

/**
 * CategoryPage: SEO-friendly canonical URL /servers/category/:categoryId.
 * Renders the same Browse UI but pre-filtered, with distinct SEO tags.
 */
export default function CategoryPage() {
  const { categoryId } = useParams();
  const [state, setState] = useState({ loading: true, valid: false, category: null });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/categories");
        const category = data.find((c) => c.id === categoryId);
        setState({ loading: false, valid: !!category, category });
      } catch {
        setState({ loading: false, valid: false, category: null });
      }
    })();
  }, [categoryId]);

  if (state.loading) return null;
  if (!state.valid) return <Navigate to="/servers" replace />;
  return <Browse routeCategory={state.category} />;
}
